/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_BrowserInputs */

const en_gc_resources_download_browser = /** @type {(inputs: Gc_Resources_Download_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer to stay in your browser?`)
};

const zh_gc_resources_download_browser = /** @type {(inputs: Gc_Resources_Download_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想继续使用浏览器？`)
};

/**
* | output |
* | --- |
* | "Prefer to stay in your browser?" |
*
* @param {Gc_Resources_Download_BrowserInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_browser = /** @type {((inputs?: Gc_Resources_Download_BrowserInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_BrowserInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_browser(inputs)
	return zh_gc_resources_download_browser(inputs)
});
export { gc_resources_download_browser as "gc.resources.download.browser" }